import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getPresence = async (dateRange, siteId) => {
  if (!dateRange || dateRange.length !== 2) {
    return Promise.resolve({ data: [] });
  }

  const params = {
    startDate: dateRange[0].format("YYYY-MM-DD"),
    endDate: dateRange[1].format("YYYY-MM-DD"),
  };

  if (siteId) {
    params.site = siteId;
  }

  return userRequest.get(`${DOMAIN}/api/presence`, { params });
};

export const getAbsentToday = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/absence_today`);
};


export const getRetardToday = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/retard_today`);
};


export const getPresencePlanning = async (dateRange) => {
  return userRequest.get(`${DOMAIN}/api/presence/planning`, {
    params: dateRange ?? {}
  });
};

export const getPresenceRapport = async ({ month, year, site }) => {
  return userRequest.get(`${DOMAIN}/api/presence/month`, {
    params: {
      month,
      year,
      site
    }
  });
};

/* export const getPresenceSite = async ({ month, year, site }) => {
  return userRequest.get(`${DOMAIN}/api/presence/presence_site_month`, {
    params: {
      month,
      year,
      site
    }
  });
};
 */

export const getPresenceRetardPonctualite = async (dateRange, site) => {
  if (!dateRange || dateRange.length !== 2) {
    return userRequest.get(`${DOMAIN}/api/presence/lateEarly`, {
      params: {
        site
      }
    });
  }

  return userRequest.get(`${DOMAIN}/api/presence/lateEarly`, {
    params: {
      startDate: dateRange[0].format("YYYY-MM-DD"),
      endDate: dateRange[1].format("YYYY-MM-DD"),
      site
    }
  });
};

export const getAttendanceAdjustment = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/attendance-adjustments`);
};

export const postAttendanceAdjustment = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/attendance-adjustments`, data);
};

export const validateAttendanceAdjustment = async (data) => {
  return userRequest.put(`${DOMAIN}/api/presence/validation-adjustments`, data);
};

export const getHRGlobalReport = async (dateRange) => {
  if (!dateRange || dateRange.length !== 2) {
    return userRequest.get(`${DOMAIN}/api/presence/hrglobal`);
  }

  return userRequest.get(`${DOMAIN}/api/presence/hrglobal`, {
    params: {
      startDate: dateRange[0].format("YYYY-MM-DD"),
      endDate: dateRange[1].format("YYYY-MM-DD")
    }
  });
};

export const getPresenceById = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/presenceById`);
};

export const postPresence = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence`, data);
};

//Dashboard
export const getPresenceDashboard = async (filters = null) => {
  let url = `${DOMAIN}/api/presence/dashboard`;
  
  if (filters) {
    const params = new URLSearchParams();
    
    if (filters.period) params.append('period', filters.period);
    if (filters.userIds?.length) params.append('userIds', filters.userIds.join(','));
    if (filters.siteIds?.length) params.append('siteIds', filters.siteIds.join(','));
    if (filters.departementIds?.length) params.append('departementIds', filters.departementIds.join(','));
    
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
  }
  
  return userRequest.get(url);
};

export const getPresenceDashboardParSite = async (filters = null) => {
  let url = `${DOMAIN}/api/presence/dashboardParSite`;
  
  if (filters) {
    const params = new URLSearchParams();
    
    if (filters.period) params.append('period', filters.period);
    if (filters.userIds?.length) params.append('userIds', filters.userIds.join(','));
    if (filters.siteIds?.length) params.append('siteIds', filters.siteIds.join(','));
    if (filters.departementIds?.length) params.append('departementIds', filters.departementIds.join(','));
    
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
  }
  
  return userRequest.get(url);
};

export const getPresenceDashboardParSiteById = async (id) => {
  return userRequest.get(`${DOMAIN}/api/presence/dashboardParBySite`, {
    params: {
      siteId : id
    }
  });
};

export const getPresenceDashboardStatisque = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/dashboardStatistique`);
};

export const getPresenceDashboardPerformance = async (params) => {
  const response = await userRequest.get(
    `${DOMAIN}/api/presence/dashboardPerformance`,
    { params }
  );

  return response.data.data; 
};

//Congé
export const getConge = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/conge`);
};

export const postConge = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/conge`, data);
};

export const validateConge = async (data) => {
    return userRequest.put(`${DOMAIN}/api/presence/validation_conge`, data)
};

//Absence
export const getAbsence = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/absence`);
};

export const getAbsenceType = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/absence_type`);
};

export const postAbsence = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/absence`, data);
};

export const validateAbsence = async (data) => {
  return userRequest.put(`${DOMAIN}/api/presence/absence-validation`, data);
};

export const getJourFerie = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/jour-ferie`);
};

export const postJourFerie = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/jour-ferie`, data);
};

//Horaire
export const getHoraire = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/horaire`);
};

export const getHoraireUser = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/horaire_user`);
};

export const postHoraire = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/create_horaire`, data);
};

export const postHoraireUser = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/planning_employe`, data);
};

//Rapport par site
export const getRapportPresenceSite = async (date_debut, date_fin) => {
  return userRequest.get(`${DOMAIN}/api/presence/rapport_presense_site`, {
    params: {
      date_debut,
      date_fin
    }
  });
};

export const getRapportPresenceDepartement = async (params) => {
  return userRequest.get(
    `${DOMAIN}/api/presence/rapport_presense_departement`,
    { params }
  );
};

export const getRapportPresenceAuditLog = async (params) => {
  return userRequest.get(
    `${DOMAIN}/api/presence/rapport_audit_log`,
    { params }
  );
};


//Terminal
export const getTerminal = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/terminal`);
};

export const getTerminalById = async (id) => {
  return userRequest.get(`${DOMAIN}/api/presence/terminalById`, {
    params : {
      id_terminal : id
    }
  });
};

export const postTerminal = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/terminal`, data);
};

export const putTerminal = async (data) => {
  return userRequest.put(`${DOMAIN}/api/presence/terminal`, data);
};


//User Terminal
export const getUserTerminal = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/user-terminal`);
};

export const getUserTerminalById = async (id) => {
  return userRequest.get(`${DOMAIN}/api/presence/user-terminalById`,{
    params: {
      id_terminal: id
    }
  })
}

export const postUserTerminal = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/user-terminal`, data);
};

export const deleteUserTerminal = (user_id, terminal_id) => {
  return userRequest.delete(`/user-terminals`, 
    {
      params: {
        user_id, 
        terminal_id
      }
    }
  );
};

//Code QR
export const getGenerateQRAll = async () => {
  return userRequest.get(`${DOMAIN}/api/presence/qr/generateAll`);
};

export const getGenerateQR = async (data) => {
  return userRequest.post(`${DOMAIN}/api/presence/qr/generate`, data);
};

// presenceService.js
export const getValidateQR = async (data) => {
  try {
    const response = await userRequest.post(`${DOMAIN}/api/presence/qr/validate`, data);
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorData = error.response.data;
      throw {
        code: errorData.code || 'API_ERROR',
        message: errorData.message || 'Erreur lors du pointage',
        status: error.response.status,
        data: errorData
      };
    } else if (error.request) {
      // La requête a été faite mais pas de réponse
      throw {
        code: 'NETWORK_ERROR',
        message: 'Impossible de contacter le serveur',
        status: 0
      };
    } else {
      // Erreur lors de la configuration de la requête
      throw {
        code: 'REQUEST_ERROR',
        message: error.message || 'Erreur de requête',
        status: 0
      };
    }
  }
};